import { useState } from "react";
import { Button, Col } from "reactstrap";
import { ClickOut } from "../../../../../constants";
import CommonThemeModalTitle from "../common/CommonThemeModalTitle";
import CustomModal1Body from "./CustomModal1Body";
import { dynamicImage } from "../../../../../utils";
import { Image } from "../../../../../coreComponents/Image";

const CustomModal1 = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <Col xl="4" md="6" className="text-center">
      <div className="card-wrapper border rounded-3 h-100">
        <div>
          <CommonThemeModalTitle heading="Modal 1 -" subHeading="Profile Modal" text="Example of aria dashboard profile card." />
          <div className="overflow-hidden">
            <Image className="img-fluid" src={dynamicImage(`alert/social.png`)} alt="social" />
            <Button color="primary" className="mx-auto mt-3" onClick={toggle}>
              {ClickOut}
            </Button>
          </div>
          <CustomModal1Body modal={modal} toggle={toggle} />
        </div>
      </div>
    </Col>
  );
};
export default CustomModal1;
